import { signal } from '@preact/signals-react';
import jsonData from './jsonData';

const translations = signal({
	leftPanel: {
		map: {},
		exhibitionInfo: {},
		exhibitorList: {
			all: {},
			allExhibitors: {},
			search: {},
		},
		myFavorite: {},
		navigationPoints: {},
		endNavigation: {},
		recommendedRoutes: {},
		advancedSearch: {
			searchExhibitor: {},
			searchProduct: {},
			exhibitor: {},
			product: {},
			submit: {},
			selectAll: {},
			clearAll: {},
			noResult: {},
			restart: {},
		},
		downloadPrint: {
			singleFloor: {},
			allMaps: {},
			exhibitorList: {},
			exhibitorName: {},
			boothNumber: {},
			myFavorite: {},
			portrait: {},
			landscape: {},
		},
	},
	rightPanel: {
		language: {},
		floors: {},
		keys: {
			myFavorite: {},
			searchResult: {},
		},
	},
	exhibitorPopup: {
		booth: {},
		navigationPath: {},
		recommended: {},
		showMore: {},
	},
	mobile: {
		mapKeys: {},
	},
	print: {
		exhibitorList: {},
		exhibitorName: {},
		boothNumber: {},
		favorite: {},
	},
	map: {
		setNavigationPoint: {},
	},
	route: {
		cancelRoute: {},
		backToMap: {},
		routeName: {},
		stop: {},
		floorPassage: {},
		copyLink: {},
		copySummary: {},
		qrCode: {},
		routeSummary: {},
		exhibitionName: {},
		routeIntro: {},
	},
});

fetch('./translations.json')
	.then((response) => response.json())
	.then((data) => {
		console.log('translations', data);
		translations.value = data;
	})
	.catch(() => {
		alert('匯入翻譯資料錯誤');
	});

const translation = (key) => {
	const keys = key.split('.');
	let result = translations.value;

	for (let i = 0; i < keys.length; i++) {
		result = result[keys[i]];
	}

	return result[jsonData.value.currentLanguage.code] || '';
};

export default translation;
